import { Tag, useDisclosure } from '@chakra-ui/react';
import { formatPercent } from '~/common/utils/formatter';
import { BidAskDetails } from './KeyTermsRow';
import { PurchasePriceTooltip } from './PurchasePriceTooltip';
import { getSaleListColor } from './common.utils';

export const BidAskTag = ({
  bidAsk,
  listPrice,
  placeholder,
}: {
  bidAsk: BidAskDetails;
  listPrice?: number;
  placeholder?: number;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const isPositive =
    !!bidAsk.max && !!bidAsk.min
      ? bidAsk.max - 1 > 0 && bidAsk.min - 1 >= 0
      : bidAsk.avg - 1 > 0;

  const isNegative =
    !!bidAsk.max && !!bidAsk.min
      ? bidAsk.max - 1 <= 0 && bidAsk.min - 1 < 0
      : bidAsk.avg - 1 < 0;

  const avgDiff = bidAsk.avg - 1;

  const displayText =
    bidAsk.min != null && bidAsk.max != null
      ? (() => {
          const minDiff = bidAsk.min - 1;
          const maxDiff = bidAsk.max - 1;
          const isMixedRange =
            (minDiff < 0 && maxDiff > 0) || (minDiff > 0 && maxDiff < 0);

          if (isMixedRange) {
            return `${formatPercent(minDiff)} to ${formatPercent(
              maxDiff
            )} vs list`;
          }

          return `${formatPercent(minDiff)} to ${formatPercent(maxDiff)} ${
            isPositive ? 'over' : 'under'
          } list`;
        })()
      : `${isPositive ? '+' : ''}${formatPercent(avgDiff)} ${
          isPositive ? 'over' : 'under'
        } list`;

  return (
    <PurchasePriceTooltip
      bidAsk={bidAsk}
      isOpen={isOpen}
      listPrice={listPrice}
      placeholder={placeholder}
    >
      <Tag
        alignItems={{ base: 'start', sm: 'center' }}
        borderRadius="3px"
        color={getSaleListColor(isPositive, isNegative)}
        display="flex"
        flexDirection={{ base: 'column', sm: 'row' }}
        gap={{ base: 0, sm: 1 }}
        size="sm"
        onClick={onOpen}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
      >
        <span>Comps:</span>
        <span>{displayText}</span>
      </Tag>
    </PurchasePriceTooltip>
  );
};
